<template>
  <v-container style="max-width: 95% !important; justify-self: center !important;" class="ma-0 pa-0">
    <v-alert-dialog
      ref="alert"
    >
    </v-alert-dialog>

    <br>
    <EstadisticaDiagnosticosSinValidar
      ref="estadisticas"
     />

    <v-row style="max-width: 1800px !important;">
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading || saving"
          :page="page"
          :items-per-page="itemsPerPage"
          :server-items-length="totalRecords"
          hide-default-footer
          @update:page="onTableWantsPage"
          :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
        >
          <template v-slot:[`item.diagnosticos_medicos_seleccionados`]="{ item }">
            <template v-if="item.id_usuario_valido == null">
              <v-autocomplete
                v-model="item.ids_diagnosticos_medicos_seleccionados"
                :items="getDiagnosticosMedicosGrupos(item.ids_diagnosticos_medicos_recomendados)"
                :loading="loadingDiagnosticosMedicos"
                dense
                hide-details
                outlined
                item-value="id_diagnostico_medico"
                item-text="diagnostico"
                multiple
                chips
                deletable-chips
                class="py-2"
                :filter="filterInsensitive"
                :disabled="saving"
              >
              </v-autocomplete>
            </template>
            <template v-else>

            </template>
          </template>
        </v-data-table>
        <br>
        <v-btn
          color="primary"
          block
          :disabled="numAsignaciones <= 0 || saving"
          @click="save"
        >
          <v-icon>
            mdi-content-save
          </v-icon>
          Guardar {{numAsignaciones}} Diagnosticos Homologados
        </v-btn>
        <br>
        <v-pagination
          :value="page"
          :length="pages"
          :total-visible="7"
          @input="onPaginationWantsPage"
        />
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
import axios from 'axios'

import EstadisticaDiagnosticosSinValidar from './EstadisticaDiagnosticosSinValidar.vue';

export default {
  components: {
    EstadisticaDiagnosticosSinValidar
  },
  data: () => ({
    items: [],
    totalRecords: 0,
    page: 1,
    itemsPerPage: 10,
    lastGoodPage: 1, // para recordar la última página válida
    loading: false,
    saving: false,
    headers: [
      {
        text: "Frecuencia",
        value: "frecuencia",
        align: "center",
        sortable: false,
        width: '26%'
      },
      {
        text: "Diagnostico",
        value: "diagnostico_heterogeneo",
        align: "center",
        sortable: false,
        width: '37%'
      },
      {
        text: "Diagnosticos Medicos Equivalentes",
        value: "diagnosticos_medicos_seleccionados",
        align: "center",
        sortable: false,
        width: '37%'
      },
    ],
    loadingDiagnosticosMedicos: false,
    diagnosticoMedicos: []
  }),
  mounted(){
    this.getItems();
    this.getDiagnosticosMedicos();
  },
  computed: {
   numAsignaciones() {
      return this.items.filter(x =>
        x.ids_diagnosticos_medicos_seleccionados.length > 0 &&
        !this.arraysSonIguales(
          x.ids_diagnosticos_medicos_seleccionados_originales,
          x.ids_diagnosticos_medicos_seleccionados
        )
      ).length;
    },
    pages() {
      return Math.max(1, Math.ceil(this.totalRecords / this.itemsPerPage));
    }
  },
  methods: {
    validateBeforePageChange() {
      if(this.numAsignaciones > 0 ){
        this.$refs.alert.setMessage('', `No puede continuar sin antes guardar los diagnósticos médicos que ya ha homologado`);
        this.$refs.alert.open();
        return false;
      }
      return true;
    },

    // Cuando el usuario hace click en el paginador externo
    onPaginationWantsPage(newPage) {
      if (this.validateBeforePageChange()) {
        this.page = newPage;
        this.lastGoodPage = newPage;
        this.getItems(); // carga server-side
      } else {
        // Revertir visualmente el control si cambió
        // (v-pagination usa :value, así que basta con NO cambiar this.page)
        // Forzar un pequeño “tick” si notas desincronización:
        this.$nextTick(() => (this.page = this.lastGoodPage));
      }
    },
    // Si alguien intenta cambiar página desde el data-table (teclas, footer si no lo ocultas, etc.)
    onTableWantsPage(newPage) {
      if (this.validateBeforePageChange(newPage)) {
        this.page = newPage;
        this.lastGoodPage = newPage;
        this.getItems();
      } else {
        this.$nextTick(() => (this.page = this.lastGoodPage));
        console.log("[DataTable] Validación falló, se cancela cambio de página.");
      }
    },
    getItems(){
      this.loading = true;
      const url = new URL(`http://localhost/DiagnosticoMedicoHeterogeneo/Listar`);
      url.searchParams.append("page", this.page);
      url.searchParams.append("size", this.itemsPerPage);
      var url_string = url.href.replace('http://localhost', '');

      axios
      .get(url_string)
      .then(response => {
        this.items = response.data.results.map(obj => {
            return { ...obj, ids_diagnosticos_medicos_seleccionados_originales: obj.ids_diagnosticos_medicos_seleccionados };
          });
        this.totalRecords = response.data.total_records;
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.loading = false;
      })
    },
    getDiagnosticosMedicos(){
      this.loadingDiagnosticosMedicos = true;
      axios
        .get('/Catalogos/ListarDiagnosticosMedicos')
        .then(response => {
          this.diagnosticoMedicos = response.data;
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.loadingDiagnosticosMedicos = false;
        })
    },
    getDiagnosticosMedicosGrupos(ids_diagnosticos_medicos_recomendados) {
      // Sin recomendaciones → devolvemos lista normal
      if (!ids_diagnosticos_medicos_recomendados || ids_diagnosticos_medicos_recomendados.length === 0)
        return this.diagnosticoMedicos;

      // Filtramos los recomendados
      const diagnosticos_recomendados = this.diagnosticoMedicos.filter(x =>
        ids_diagnosticos_medicos_recomendados.includes(x.id_diagnostico_medico)
      );

      if (diagnosticos_recomendados.length === 0)
        return this.diagnosticoMedicos;

      // El resto
      const otros_diagnosticos = this.diagnosticoMedicos.filter(x =>
        !ids_diagnosticos_medicos_recomendados.includes(x.id_diagnostico_medico)
      );

      // Retornamos estructura plana
      return [
        { header: 'Recomendados' },
        ...diagnosticos_recomendados,
        { divider: true },
        { header: 'Otras Opciones' },
        ...otros_diagnosticos
      ];
    },
    normalize(text) {
      return (text || '')
        .toString()
        .normalize('NFD')             // separa letras y acentos
        .replace(/[\u0300-\u036f]/g, '') // elimina los acentos
        .toLowerCase()
        .trim();
    },
    // Filtro personalizado para v-autocomplete
    filterInsensitive(item, queryText, itemText) {
      const text = this.normalize(itemText || item.diagnostico || '');
      const query = this.normalize(queryText);
      return text.indexOf(query) > -1;
    },
    arraysSonIguales(a, b) {
      if (!Array.isArray(a) || !Array.isArray(b)) return false;
      if (a.length !== b.length) return false;

      const sa = [...a].sort();
      const sb = [...b].sort();
      return sa.every((val, i) => val === sb[i]);
    },
    save(){
      this.saving = true;

      var payload = this.items.filter(x =>
        x.ids_diagnosticos_medicos_seleccionados.length > 0 &&
        !this.arraysSonIguales(
          x.ids_diagnosticos_medicos_seleccionados_originales,
          x.ids_diagnosticos_medicos_seleccionados
        )
      )
      .map(obj => {
        return {
          id_diagnostico_medico_heterogeneo: obj.id_diagnostico_medico_heterogeneo,
          ids_diagnosticos_medicos_seleccionados: obj.ids_diagnosticos_medicos_seleccionados
        };
      });

      axios
      .post('/DiagnosticoMedicoHeterogeneo/GuardarAsignaciones', payload)
      .then(() => {
        this.getItems();
        this.$refs.estadisticas.getStats();
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.saving = false;
      })
    }
  }
}
</script>